// extracted by mini-css-extract-plugin
var _1 = "UploadImageModalStageArea-modulefullBleedStage__ir3Og";
var _2 = "UploadImageModalStageArea-modulestageArea__hoxHO";
var _3 = "UploadImageModalStageArea-modulestageAreaFullScreen__Wkohj";
var _4 = "UploadImageModalStageArea-modulestatePanel__TcHls";
export { _1 as "fullBleedStage", _2 as "stageArea", _3 as "stageAreaFullScreen", _4 as "statePanel" }
